import React, { useEffect, useState } from "react"

import './styles.css';
import PageTitle from "../../../../components/Accessibility/PageTitle";
import DefaultText from "../../../../components/Accessibility/DefaultText";
import { usePrimeiroAgendamentoContext } from "../contexts/PrimeiroAgendamentoContext";
import { getBoasVindasAdesao } from "../../../../services/SaudeBemEstar/PrimeiroAgendamentoService";
import { getBenef } from "../../../../Store/storages/BeneficiarioStorage";
import { IBoasVindasItem } from "../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/BoasVindas";
import { InformationCard } from "./InformationCard";
import VoltarButton from "../../../../components/Accessibility/VoltarButton";
import LoadingApp from "../../../../components/LoadingApp";
import ButtonAccessibility from "../../../../components/Accessibility/ButtonAccessibility";

export const BoasVindas: React.FC = () => {
    const { setSteps } = usePrimeiroAgendamentoContext()
    const [title, setTitle] = useState<string>('')
    const [items, setItems] = useState<IBoasVindasItem[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const benef = getBenef();

    useEffect(() => {
        setLoading(true)
        getBoasVindasAdesao().then((response) => {
            setTitle(response.titulo)
            setItems(response.items)
        }).finally(() => setLoading(false))
    }, [])

    return (
        <div className='page-container'>
            <LoadingApp showLoading={loading} text={'Carregando...'} />
            <PageTitle text="Gestão de Crônicos" />
            <DefaultText text={`${benef?.nome}, ${title}`} />
            {items.map((item, index) =>
                <InformationCard key={index} item={item} />
            )}
            <div className="page-container-button">
                <ButtonAccessibility
                    variant="contained"
                    fullWidth
                    onClick={() => setSteps((prev) => prev + 1)}
                >
                    CONTINUAR
                </ButtonAccessibility>
            </div>
            <VoltarButton
                onClick={() => setSteps((prev) => prev - 1)} />
        </div>
    )
}